import * as React from 'react';

const WheelIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="none"
    {...props}
  >
    <mask
      id="a"
      width={32}
      height={32}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path fill="#D9D9D9" d="M0 0h32v32H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#004A68"
        d="M16.004 28c-1.659 0-3.22-.315-4.68-.945a12.126 12.126 0 0 1-3.812-2.564 12.108 12.108 0 0 1-2.566-3.808c-.63-1.46-.946-3.02-.946-4.679 0-1.659.315-3.22.945-4.68a12.128 12.128 0 0 1 2.564-3.812 12.108 12.108 0 0 1 3.808-2.566c1.46-.63 3.02-.946 4.679-.946 1.659 0 3.22.315 4.68.945 1.46.63 2.731 1.484 3.812 2.564a12.108 12.108 0 0 1 2.566 3.808c.63 1.46.946 3.02.946 4.679 0 1.659-.315 3.22-.945 4.68a12.126 12.126 0 0 1-2.564 3.812 12.107 12.107 0 0 1-3.808 2.566c-1.46.63-3.02.946-4.679.946Zm-3.935-1.718 2.536-5.872a4.924 4.924 0 0 1-1.816-1.119 4.589 4.589 0 0 1-1.148-1.837l-5.974 2.41c.62 1.51 1.48 2.816 2.579 3.92a10.873 10.873 0 0 0 3.823 2.498Zm-.436-11.728a3.86 3.86 0 0 1 1.09-1.82 5.04 5.04 0 0 1 1.823-1.093l-2.41-5.974c-1.564.62-2.898 1.488-4.003 2.604a10.702 10.702 0 0 0-2.466 3.873l5.966 2.41Zm4.361 5.036c.996 0 1.844-.349 2.544-1.046.701-.696 1.052-1.542 1.052-2.538 0-.996-.349-1.844-1.046-2.544-.696-.701-1.542-1.052-2.538-1.052-.996 0-1.844.349-2.544 1.046-.701.696-1.052 1.542-1.052 2.538 0 .996.349 1.844 1.046 2.544.696.701 1.542 1.052 2.538 1.052Zm3.962 6.692a11.38 11.38 0 0 0 6.326-6.351l-5.872-2.528a4.385 4.385 0 0 1-1.124 1.85 4.732 4.732 0 0 1-1.814 1.106l2.484 5.923Zm.403-11.787 5.923-2.451A11.418 11.418 0 0 0 23.76 8.24a11.418 11.418 0 0 0-3.804-2.522l-2.443 5.923a5.16 5.16 0 0 1 1.7 1.101c.494.48.876 1.064 1.146 1.753Z"
      />
    </g>
  </svg>
);

export default WheelIcon;
